/**
 * IMPORT TRANSLATIONS FOR ALL PAGES
 * Path being matched: @/pages/<pagename>/translation/russian/index.js
 * Make sure to follow this path in order for auto-import to work
 * Always export const <pagename><Array> = [paths_object<Object>]
 */

const requireLanguages = require.context('@', true, /translation\/russian.*\.js$/)
const languagesUnparsed = []
const lang = {}

requireLanguages.keys().forEach(key => {
  languagesUnparsed.push(requireLanguages(key))
})

languagesUnparsed.forEach(el => {
  Object.keys(el).forEach(key => {
    lang[key] = el[key]
  })
})

export const ru_RU = lang
